import { Controller } from "@hotwired/stimulus"

// Reusable floating snackbar. Controls show/hide animation via class swap.
// Content is provided by the caller; this controller knows nothing about it.
export default class extends Controller {
  static classes = ["visible", "hidden"]

  show() {
    this.element.classList.add(...this.visibleClasses)
    this.element.classList.remove(...this.hiddenClasses)
  }

  hide() {
    this.element.classList.remove(...this.visibleClasses)
    this.element.classList.add(...this.hiddenClasses)
  }

  toggle() {
    const visible = this.visibleClasses.every(c => this.element.classList.contains(c))
    visible ? this.hide() : this.show()
  }
}
